// components/MergedPdfPrint.js
import React, { forwardRef } from 'react';

const MergedPdfPrint = forwardRef(({ blobUrl }, ref) => (
    <div ref={ref} style={{ display: 'none' }}>
        <iframe
            src={blobUrl}
            style={{ width: '1000px', height: '1414px', border: 0 }} // A4 portrait, but hidden
            title="merged‑pdf"
        />
    </div>
));

export default MergedPdfPrint;
